import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Dialog from 'components/dialog'
import { useDialogTitleStyles } from 'components/dialog/use-dialog-title-styles'
import { useTerminateIntercomSession } from 'lib/support'
import { assumeUser } from './impersonation'
import useAuth from './useAuth'

const ImpersonateUserDialog = ({ trigger, user, hideSensitiveInformation }) => {
  const classes = useDialogTitleStyles()
  const { user: currentUser } = useAuth()
  const terminateIntercomSession = useTerminateIntercomSession()
  const { userType, id, name } = user

  const isSameUser =
    `${currentUser.type}/${currentUser.id}` === `${userType}/${id}`

  // disable the ability to impersonate yourself, or to impersonate again while impersonating someone else
  if (isSameUser || currentUser.isAssumed) return null

  return (
    <Dialog
      trigger={trigger}
      maxWidth="xs"
      fullWidth
      showCloseButton
      classes={{ paper: classes.dialogPaper }}
    >
      {({ closeDialog }) => (
        <>
          <DialogTitle disableTypography classes={{ root: classes.titleRoot }}>
            <Typography component="h2" className={classes.title}>
              Impersonate User
            </Typography>
            <Typography className={classes.bodyText}>
              Are you sure you want to impersonate {name}? Any updates you make
              will also be reflected in their account.
            </Typography>
          </DialogTitle>
          <DialogActions className={classes.actions}>
            <Button color="primary" size="large" onClick={closeDialog}>
              Cancel
            </Button>
            <Button
              color="primary"
              variant="contained"
              size="large"
              disableElevation
              onClick={() => {
                terminateIntercomSession()
                assumeUser({ userType, id, hideSensitiveInformation })
              }}
            >
              Impersonate User
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  )
}

export default ImpersonateUserDialog
